import { TFunction } from 'i18next';
import { number, object } from 'yup';

export function getValidator(t: TFunction) {
  return object().shape({
    code: number().required(t('required_field')).typeError(t('invalid_code')),
  });
}
